var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { AppDisplay } from '@ui/applications/AppDisplay';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { NotificationFrequencyTag } from './NotificationFrequencyTag';
import React from 'react';
import { SonarStakeholder } from '@ui/SonarStakeholder';
import { DataSecurityMonitorType } from '@sonar-software/sonar-core';
import { monitorParentType, MonitorTypeTag } from './MonitorTypeTag';
import { Space, Switch } from 'antd';
export const nameColumn = {
    className: 'monitor-name',
    dataIndex: 'name',
    fixed: true,
    key: 'name',
    title: COPY_SPECIFIC.NAME,
    width: 160
};
export const typeColumn = {
    dataIndex: ['monitorConfig', 'monitorTypeId'],
    key: 'monitorTypeId',
    render: (monitorTypeId) => React.createElement(MonitorTypeTag, { monitorTypeId: monitorTypeId }),
    title: COPY_SPECIFIC.TYPE,
    width: 150
};
export const appColumn = {
    dataIndex: 'applicationId',
    key: 'applicationId',
    render: (applicationId) => (applicationId ? React.createElement(AppDisplay, { appId: applicationId }) : null),
    title: COPY_SPECIFIC.APP,
    width: 120
};
export const emailColumn = {
    dataIndex: 'stakeholderIds',
    key: 'stakeholderIds',
    render: (stakeholderIds) => React.createElement(Space, { direction: 'horizontal', size: [32, 8], wrap: true }, stakeholderIds.map((id) => React.createElement(SonarStakeholder, { key: id, stakeholderId: id }))),
    title: COPY_SPECIFIC.EMAIL_NOTIFICATIONS,
    width: 170
};
export const frequencyColumn = {
    dataIndex: ['monitorConfig', 'monitoringWindow'],
    key: 'monitoringWindow',
    render: (monitoringWindow, record) => React.createElement(NotificationFrequencyTag, { frequency: monitoringWindow !== null && monitoringWindow !== void 0 ? monitoringWindow : record.notificationSchedule }),
    title: COPY_SPECIFIC.NOTIFICATION_FREQUENCY,
    width: 120
};
export const muteColumn = (toggle) => ({
    align: 'center',
    dataIndex: 'isMuted',
    key: 'mute',
    render: (_, record) => {
        var _a;
        const { isMuted } = record, monitor = __rest(record, ["isMuted"]);
        const id = (_a = monitorParentType[monitor.monitorConfig.monitorTypeId]) !== null && _a !== void 0 ? _a : monitor.monitorConfig.monitorTypeId;
        if (id === DataSecurityMonitorType.Personal) {
            return null;
        }
        return (React.createElement(Switch, { checked: record.isMuted, onChange: (mute) => toggle(mute, monitor.id) }));
    },
    title: COPY_SPECIFIC.GLOBAL_MUTE,
    width: 120
});
export const subscribeColumn = (userId, toggle) => ({
    align: 'center',
    dataIndex: 'stakeholderIds',
    key: 'subscribe',
    render: (stakeholderIds, record) => React.createElement(Switch, { checked: stakeholderIds.includes(userId), onChange: (subscribe) => toggle(subscribe, record.id) }),
    title: COPY_SPECIFIC.SUBSCRIBE,
    width: 120
});
export function getColumns(readOnly, userId, toggleMute, toggleSubscribe) {
    if (readOnly) {
        return [
            nameColumn,
            typeColumn,
            appColumn,
            emailColumn,
            frequencyColumn,
            subscribeColumn(userId, toggleSubscribe)
        ];
    }
    return [
        nameColumn,
        typeColumn,
        appColumn,
        emailColumn,
        frequencyColumn,
        muteColumn(toggleMute),
        subscribeColumn(userId, toggleSubscribe)
    ];
}
